import { type ReactElement, type ReactNode } from 'react';
import debounce from 'lodash/debounce';
import kebabCase from 'lodash/kebabCase';
import classnames from 'classnames';
import { analytics } from 'libs';
import { Tooltip } from 'components/common';
import { QuestionCircleIcon } from 'icons';
import Upgrade from './Upgrade';

interface FilterProps {
  children: ReactNode;
  isPro?: boolean;
  name: string;
  tooltip?: ReactElement | string | null;
}

const Filter = ({ children, isPro, name, tooltip = null }: FilterProps) => {
  const trackTooltipVisibility = debounce(
    (isVisible) => (isVisible ? analytics.productSearch.tooltipDisplay(name) : null),
    1500
  );

  return (
    <div
      className={classnames(`filter filter--${kebabCase(name)}`, {
        'filter--pro': isPro,
      })}
    >
      <h3 className="d-flex align-items-center">
        {name}
        {tooltip && (
          <Tooltip className="mx-1" content={tooltip} onVisibilityChange={trackTooltipVisibility}>
            <QuestionCircleIcon className="width-4" />
          </Tooltip>
        )}
        <Upgrade isPro={isPro} onClick={analytics.upgrade.click(`Rate Filter: ${name}`)} />
      </h3>
      {children}
    </div>
  );
};

export default Filter;
